"use strict";

export default {
  ANTRAGSTELLUNG: 1,
  FOERDERORG: 2,
  SYSTEM: 3
};
